import 'react-international-phone/build/index.css';


import {
    InputAdornment,
    MenuItem,
    Select,
    TextField,
    Typography,
} from '@mui/material';
import React from 'react';
import {
    defaultCountries,
    FlagImage,
    parseCountry,
    usePhoneInput,
} from 'react-international-phone';
import { FormLabel, Grid } from '@mui/joy';
import { useTranslation } from 'react-i18next';

export const MuiPhone = ({ value, onChange, defaultCountry = 'us', ...restProps }) => {
    const { t } = useTranslation('ui');
    const { required, inputProps: userInputProps, ...textFieldProps } = restProps;
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } =
        usePhoneInput({
            defaultCountry: defaultCountry,
            value,
            countries: defaultCountries,
            onChange: (data) => {
                onChange(data.phone);
            },
        });

    return (
        <Grid>
            <FormLabel>{t('userMenu.phone')}</FormLabel>
            <TextField
            sx={{
                borderRadius: '5px', // Adjust the pixel value as per your requirement
                '& fieldset': {
                  borderRadius: '5px', // Adjust the pixel value as per your requirement
                },
              }}
                size="small"
                placeholder={t('widgets.phonePlaceholder')}
                value={inputValue}
                onChange={handlePhoneValueChange}
                type="tel"
                inputRef={inputRef}
                required={required}
                inputProps={{
                    ...userInputProps,
                    onInvalid: (e) => {
                        if (typeof userInputProps?.onInvalid === 'function') userInputProps.onInvalid(e);
                        const input = e.target;
                        if (required && input.validity.valueMissing) {
                            input.setCustomValidity(
                                t('validation.fieldRequired', { field: t('userMenu.phone') })
                            );
                        }
                    },
                    onInput: (e) => {
                        if (typeof userInputProps?.onInput === 'function') userInputProps.onInput(e);
                        e.target.setCustomValidity('');
                    },
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment
                            position="start"
                            style={{ marginRight: '2px', marginLeft: '-8px' }}
                        >
                            <Select
                                MenuProps={{
                                    style: {
                                        height: '300px',
                                        width: '360px',
                                        top: '10px',
                                        left: '-34px',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                }}
                                sx={{
                                    width: 'max-content',
                                    // Remove default outline (display only on focus)
                                    fieldset: {
                                        display: 'none',
                                    },
                                    '&.Mui-focused:has(div[aria-expanded="false"])': {
                                        fieldset: {
                                            display: 'block',
                                        },
                                    },
                                    // Update default spacing
                                    '.MuiSelect-select': {
                                        padding: '8px',
                                        paddingRight: '24px !important',
                                    },
                                    svg: {
                                        right: 0,
                                    },
                                }}
                                value={country.iso2}
                                onChange={(e) => setCountry(e.target.value)}
                                renderValue={(value) => (
                                    <FlagImage iso2={value} style={{ display: 'flex' }} />
                                )}
                            >
                                {defaultCountries.map((c) => {
                                    const country = parseCountry(c);
                                    return (
                                        <MenuItem key={country.iso2} value={country.iso2}>
                                            <FlagImage
                                                iso2={country.iso2}
                                                style={{ marginRight: '8px' }}
                                            />
                                            <Typography marginRight="8px">{country.name}</Typography>
                                            <Typography color="gray">+{country.dialCode}</Typography>
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </InputAdornment>
                    ),
                }}
                {...textFieldProps}
            />

        </Grid>

    );
};